import { roundDecimals, sum } from "@project-rouge/rg-core";
function ResizeToFill({ row, rgType, space, gap }) {
	const othersTotal = row.filter((c) => c.type !== rgType).map((c) => c.size[0] + gap).reduce(sum);
	const cores = row.filter((c) => c.type === rgType);
	const sizeX = roundDecimals((space - othersTotal - cores.length * gap) / cores.length);
	for (const c of cores) c.size[0] = sizeX;
	const lastCoreExtra = space - (othersTotal + sizeX * cores.length);
	cores[cores.length - 1].size[0] = roundDecimals(sizeX + lastCoreExtra);
}
export { ResizeToFill };

//# sourceMappingURL=index129.js.map